import { render, staticRenderFns } from "./newAdmin.vue?vue&type=template&id=5dda5d03&"
import script from "./newAdmin.vue?vue&type=script&lang=js&"
export * from "./newAdmin.vue?vue&type=script&lang=js&"
import style0 from "./newAdmin.vue?vue&type=style&index=0&id=5dda5d03&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports